<div id="main_layout_scroll" class="relative h-screen" [class.overflow-scroll]="scrollable"
  [class.overflow-hidden]="!scrollable">

  <div class="flex w-full justify-center">
    <div class="flex flex-col  px-4 py-1 md:p-0 md:bg-[#FEFEFE] md:max-w-[1920px] w-full">
      <!-- Top-Header -->
      <div
        class="flex flex-row max-h-8 mb-4 md:max-h-[100px] md:h-[100px] md:my-0 md:mx-[60px] md:flex-row md:justify-start md:items-center">
        <!--  Btns linke Seite  -->
        <div class="flex flex-row md:hidden">
          @if (backLink !== '') {
            <div class="flex gap-1 w-auto h-8 items-center justify-center">
              <fa-icon icon="chevron-left" size="xs"></fa-icon>
              <span class="font-light text-sm">Zurück</span>
            </div>
          }
        </div>
        <!--  Image  -->
        <div class="flex grow md:grow-0 md:mr-7" [class]="backLink !== '' ? 'justify-center' :'justify-start'"
          routerLink="/main">
          <img ngSrc="assets/images/logo.png" class="h-8 w-auto md:h-14 md:cursor-pointer" height="116" width="459"
            alt="logo">
        </div>
        <kaz-header-search></kaz-header-search>
        <!--  Btns rechte Seite  -->
        <div class="flex flex-row md:hidden">
          @if (!(showMenu && _auth.isAuthenticated() || isProfilePage())) {
            <div
              class="flex w-8 h-8 items-center justify-center" routerLink="/profile">
              <fa-icon icon="user" size="sm"></fa-icon>
            </div>
          }
          <div class="flex w-8 h-8 items-center justify-end" (click)="toggleMenu()">
            <fa-icon [ngClass]="{'menu-icon': showMenu}" [icon]="showMenu ? 'xmark' : 'bars'" size="sm"></fa-icon>
          </div>
        </div>
      </div>
      <!-- Bottom-Header -->
      <kaz-desktop-nav>
        @if (showAuthBtns) {
          <div
            class="flex flex-row gap-4 grow justify-end items-center text-xs text-[#161D26] font-semibold">
            <div
              class="flex justify-center items-center h-[33px] w-[186px] text-kaz-blue border border-kaz-blue rounded-full cursor-pointer"
              routerLink="/signup">
              <span>Konto erstellen</span>
            </div>
            <span class="text-sm">oder</span>
            <div
              class="flex justify-center items-center h-[33px] w-[186px] text-white bg-[#F0811A] rounded-full cursor-pointer"
              routerLink="/login">
              <span>Anmelden</span>
            </div>
          </div>
        }

        <!-- Mail & Logout -->
        @if (!showAuthBtns) {
          <div
            class="flex flex-row gap-11 grow justify-end items-center text-xs text-[#161D26] font-medium">
            <span class="cursor-pointer hover:text-kaz-blue" routerLink="/profile">{{ mail }}</span>
            <span class="text-kaz-orange font-semibold cursor-pointer hover:text-red-500" routerLink="/login" (click)="logout()">Abmelden</span>
          </div>
        }
      </kaz-desktop-nav>
      <kaz-default-info class="hidden absolute right-16 z-10 top-[180px] md:flex"></kaz-default-info>

      <div class="md:m-auto md:max-w-[1080px] md:w-full pb-10 md:pb-8">
        <ng-content>
        </ng-content>
      </div>
      @if (showMenu) {
        <kaz-menu (closeMenu)="closeMenu()"></kaz-menu>
      }
    </div>
  </div>
  <kaz-footer></kaz-footer>

</div>
